import { bake_cookie, read_cookie } from "sfcookies";

export const bakeGitTokenCookie = (token) => {
  bake_cookie("git_token", token);
};

export const readGitTokenCookie = () => {
  return read_cookie("git_token");
};
